<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">REGISTRO DE PERSONA Y DECLARACIÓN DE DOMICILIO 
          <span class="float-right" v-if="impresora">
            <div class="input-group">
              <i class="fa fa-print"></i>
              <select class="form-control ml-2" v-model="idioma" @change="guardaIdioma" >
                <option value="0">ESPAÑOL</option>
                <option value="1">INGLÉS</option>
              </select>              
            </div>
          </span>  
        </h5>
      </div>
      <div class="card-body">
        <!-- <form class="frmBusqueda" @submit.prevent="registraExtranjero"> -->
        <div class="row">
          <div class="col-12 col-md-4" style="border-right:1px solid #ccc;">
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label>Nombres:
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_nombres.required">* Campo requerido</span>
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_nombres.letras">Solo debe ingresar letras</span>
                </label>
                <input
                  type="text"
                  placeholder="Nombres..."
                  v-model.trim="$v.extranjero.per_nombres.$model"
                  class="form-control"
                  :class="{'is-invalid': $v.extranjero.per_nombres.$error}"
                  @keyup="extranjero.per_nombres = extranjero.per_nombres.toUpperCase()"
                />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label>Primer Apellido:
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_primer_apellido.required">* Campo requerido</span>
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_nombres.minLength">Ingrese al menos 2 caracteres</span>
                </label>
                <input
                  type="text"
                  placeholder="Primer Apellido..."
                  v-model.trim="extranjero.per_primer_apellido"
                  class="form-control"
                  :class="{'is-invalid': $v.extranjero.per_primer_apellido.$error}"
                  @keyup="extranjero.per_primer_apellido = extranjero.per_primer_apellido.toUpperCase()"
                />
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12 col-md-12">
                <label>Segundo Apellido:
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_segundo_apellido.minLength">Ingrese al menos 2 caracteres</span>
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_segundo_apellido.letras">Solo debe ingresar letras</span> 
                </label>
                <input
                  type="text"
                  placeholder="Segundo Apellido..."
                  v-model.trim="extranjero.per_segundo_apellido"
                  class="form-control"
                  @keyup="extranjero.per_segundo_apellido = extranjero.per_segundo_apellido.toUpperCase()"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="row form-group">
              <div class="col-12 col-md-7">
                <label>Tipo Documento:
                  <span class="text-danger lb-error" v-if="!$v.extranjero.par_tipo_documento.required">* Campo requerido</span>
                </label>
                <select
                  class="form-control"
                  v-model="extranjero.par_tipo_documento"
                  :class="{'is-invalid': $v.extranjero.par_tipo_documento.$error}"
                >
                  <option value="">SELECCIONAR</option>
                  <option v-for="(item, index) in tipoDocumentos" :value="item.codigo" :key="index">{{ item.nombre }}</option>
                </select>
              </div>
              <div class="col-12 col-md-5">
                <label>Nro. Documento:
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_numero_documento.required" >* Campo requerido</span>
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_numero_documento.minLength">* Ingresar al menos 5 caracteres</span> 
                </label>
                <input
                  type="text"
                  placeholder="Nro Documento..."
                  class="form-control"
                  v-model.trim="extranjero.per_numero_documento"
                  :class="{'is-invalid': $v.extranjero.per_numero_documento.$error}"
                  @keyup="extranjero.per_numero_documento = extranjero.per_numero_documento.toUpperCase()"
                />
              </div>
            </div>
            <div class="row form-group">
              
              <div class="col-12 col-md-4">
                <label>Fecha Nacimiento:
                 <!-- <span class="text-danger lb-error" v-if="!$v.extranjero.per_fecha_nacimiento.required">* Campo requerido</span> -->
                </label>
                <input
                  type="date"
                  class="form form-control"
                  v-model="$v.extranjero.per_fecha_nacimiento.$model"
                  min="1920-01-01"
                  :max="fechaMin"
                  />
              </div>
               <!--<div class="col-6 col-md-4">
                <label>Género: 
                
                </label>        
                <select
                  class="custom-select"
                  v-model="extranjero.par_genero"
                  :class="{'is-invalid': $v.extranjero.par_genero.$error}"
                >
                  <option value="">SELECCIONAR</option>
                  <option value="F">FEMENINO</option>
                  <option value="M">MASCULINO</option>
                </select>
              </div> -->
              <div class="col-12 col-md-4">
                <label>Teléfono:
                <span class="text-danger lb-error" v-if="!$v.extranjero.per_telefono.required">* Campo requerido</span>
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_telefono.numero">Solo debe ingresar Numeros</span>
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_telefono.minLength">* Ingresar al menos 6 caracteres</span> 
                </label>
                <input
                  type="number"
                  placeholder="Teléfono..."
                  class="form-control"
                  v-model.trim="extranjero.per_telefono"
                  :class="{'is-invalid': $v.extranjero.per_telefono.$error}"
                  @keyup="extranjero.telefono = extranjero.per_telefono.toUpperCase()"
                />
              </div>
              <div class="col-12 col-md-4">
                <label>Nacionalidad:
                  <span class="text-danger lb-error" v-if="!$v.extranjero.par_nacionalidad.required">* requerido</span>
                </label>
                <select
                  class="form form-control"
                  v-model="extranjero.par_nacionalidad"
                  :class="{'is-invalid': $v.extranjero.par_nacionalidad.$error}"
                  @change="onChangeNaionalidad($event)"
                >
                  <option value="">SELECCIONAR</option>
                  <option v-for="(item, index) in nacionalidades" :key="index" :value="item.a3_dgm">{{ item.nombre }}</option>
                </select>
              </div>
            </div>
            <div class="row form-group">
              
              <div class="col-12 col-md-8">
                <label>Correo Electrónico:
                  <!--<span class="text-danger lb-error" v-if="!$v.extranjero.per_email.required">* Campo requerido</span>-->
                  <span class="text-danger lb-error" v-if="!$v.extranjero.per_email.email" >* Formato incorrecto</span> 
                </label>
                <input
                  type="email"
                  placeholder="Email..."
                  class="form form-control"
                  v-model.trim="extranjero.per_email"
                  :class="{'is-invalid': $v.extranjero.per_email.$error}"
                />
              </div>
              <div class="col-md-4">
                    <label>Ingreso: <span class="text-danger lb-error" v-if="!$v.extranjero.tipo_extranjero.required">Campo requerido</span></label>        
                    <select
                      class="custom-select"
                      v-model="extranjero.tipo_extranjero"
                      :class="{'is-invalid': $v.extranjero.tipo_extranjero.$error}"
                    >
                      <option value="">SELECCIONAR</option>
                      <option value="1">TURISTA</option>
                      <option value="2">RESIDENTE</option>
                    </select>
                  </div>
            </div>
          </div>
          
        </div>
        <hr />
        <!--Hospedaje-->
        <div class="row mb-4 mt-4">
          <div class="col-12 col-md-12">
            <div class="row form-group">
              <div class="col-12 col-md-12">
               <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="HOS"
                    name="tipo_domicilio"
                    id="rdHOS"
                    :class="{'is-invalid': $v.domicilio.tipo_domicilio.$error}"
                    v-model="domicilio.tipo_domicilio"
                    @change="onChangeTipoDomicilio($event)"
                  />
                  <label class="form-check-label" for="rdHOS">Centro de Hospedaje</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="RES"
                    name="tipo_domicilio"
                    id="rdRES"
                    :class="{'is-invalid': $v.domicilio.tipo_domicilio.$error}"
                    v-model="domicilio.tipo_domicilio"
                    @change="onChangeTipoDomicilio($event)"
                  />
                  <label class="form-check-label" for="rdRES">Domicilio Particular</label>
                </div> 
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="ND"
                    name="tipo_domicilio"
                    id="rdND"
                    :class="{'is-invalid': $v.domicilio.tipo_domicilio.$error}"
                    v-model="domicilio.tipo_domicilio"
                    @change="onChangeTipoDomicilio($event)"
                  />
                  <label class="form-check-label" for="rdND">No Declara</label>
                </div>
              </div>
            </div>

            <!--componentes-->
            <CentroHospedaje :domicilio="domicilio" v-show="disabledHos==1" />
            <DomicilioParticular :domicilio="domicilio" v-show="disabledRes==1" />
            <NoDeclara v-show="disabledND==1" />

          </div>
        </div>
        <div class="row">
          <div class="col-md-9"></div>
          <div class="col-md-3">
            <button type="button" class="btn btn-block btn-primary" @click="Registra" :disabled="btnDisabled">
              <small>Registrar</small>
            </button>
          </div>

        </div>
        <!-- </form> -->
      </div>
    </div>
       <b-modal
      class="modal fade"
      title="EL USUARIO YA EXISTE"
      size="xs"
      hide-footer
      ref="modal"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-group text-center">
             
             
            <img src="../../assets/informacion.png" width="35%">
          
            </div>
            <b>{{extranjero.per_nombres}} {{extranjero.per_primer_apellido}} {{extranjero.per_primer_apellido}}</b> ya fue registrado anteriormente.
            <hr />
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-10 float-right">
            <a @click="hideModal" class="btn btn-danger mr-4">Cerrar</a>
            <a @click="insertaDomicilioPersona(datosDomicilio)" class="btn btn-success">
              Insertar Declaración
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>

import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import router from "@/router";
import Loading from "../../components/Loading";
import CentroHospedaje from '../../components/analista/CentroHospedaje';
import DomicilioParticular from '../../components/analista/DomicilioParticular';
import NoDeclara from '../../components/analista/NoDeclara';
import moment from 'moment';

const letras = helpers.regex("alpha", /^[ a-zA-ZñÑäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ]*$/);
const numero = helpers.regex("alpha", /^[-1234567890]*$/);

export default {
  name: "frmPersona",
  components: {
    Loading,
    CentroHospedaje,
    DomicilioParticular,
    NoDeclara
  },
  data() {
    return {
      impresora: false,
      idioma: 0,
      datosDomicilio:[],
      extranjero: {
        per_nombres: "",
        per_primer_apellido: "",
        per_segundo_apellido: "",
        per_telefono: "",
        per_fecha_nacimiento: "",
        per_email: "",
        par_tipo_documento: "",
        per_numero_documento: "",
        par_nacionalidad: "",
        par_genero: '',
        tipo_persona: 3,
        tipo_extranjero:''
      },
      domicilio: {
        id_persona: 0,
        id_empresa: '',
        tipo_domicilio: 'ND',
        nombre_domicilio: '',
        direccion: '',
        telefono: '',
        fecha_inicio: null,
        fecha_fin: null,
        tipo_documento: '',
        nro_documento: '',
        departamento: '',
        empresa_persona: 0
      },
      persona: {
        extranjero: {},
        domicilio: {}
      },
      disabledHos: 0,
      disabledRes: 0,
      disabledND: 1,
      cargando: false,
      submitted: false,
      tipoDocumentos: [],
      options: [],
      item: {
        value: "",
        text: "",
      },
      user: {
        usr_usuario: "",
        usr_password: "",
        usr_estado_registro: 1,
        id_persona: 0,
        id_rol: 0,
      },
      empresas: [],
      nacionalidades: [],
      fechaMin: new moment().format("YYYY-MM-DD"),
      btnDisabled: false,
    };
  },
  methods: {

    async showModal(item) {
      this.datosDomicilio = item;
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    async Registra() {
      this.cargando = true;

      // validaciones persona
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }
      // Validaciones hospedaje
      if(this.disabledHos == 1){         
        this.domicilio.nro_documento = "";
        if(this.domicilio.id_empresa == undefined || this.domicilio.id_empresa == 0){
          this.$swal({
            title: 'Información',
            text: 'Seleccione una empresa',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
        if(this.domicilio.nombre_domicilio == 'EMPRESA NO SE ENCUENTRA REGISTRADA' || this.domicilio.nombre_domicilio == ""){
          this.$swal({
            title: 'Información',
            text: 'Debe completar el nombre de la empresa',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
      }

      if (this.disabledRes == 1) {
        
        this.domicilio.id_empresa = 0;
        if (this.domicilio.nombre_domicilio == undefined || this.domicilio.nombre_domicilio == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese nombre completo del titular',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
        if (this.domicilio.nro_documento == undefined || this.domicilio.nro_documento == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese número de documento del titular.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
        if (this.domicilio.direccion == undefined || this.domicilio.direccion == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese dirección del titular',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
        if (this.domicilio.telefono == undefined || this.domicilio.telefono == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese teléfono del titular.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
      }

      if(this.disabledND == 1 ){        
        this.extranjero.id_empresa = 0;
        this.domicilio.id_empresa = 0;
        this.domicilio.fecha_inicio = null;
        this.domicilio.fecha_fin = null;
      }else{        
        if (this.domicilio.departamento == undefined || this.domicilio.departamento == "") {
          this.$swal({
            title: 'Información',
            text: 'Seleccione Departamento.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
        if (this.domicilio.fecha_inicio == undefined || this.domicilio.fecha_inicio == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese la fecha inicial.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
        if (this.domicilio.fecha_fin == undefined || this.domicilio.fecha_fin == "") {
          this.$swal({
            title: 'Información',
            text: 'Ingrese la fecha final.',
            type: 'info',
            confirmButtonText: 'Aceptar'
          });
          this.cargando = false;
          return;
        }
      }

      try {    
        this.btnDisabled = true;
        this.persona = {
          extranjero: this.extranjero,
          domicilio: this.domicilio,
          idioma: this.idioma
        }
        let res = await this.axios.post(`/registraPerUsuDom`, this.persona);

        if(res.data.codigo === 1){
     
          this.cargando = false;
          this.$swal({
            title: "<strong>Persona Registrada</strong>",
            type: "success",
            html:
              "Credenciales para iniciar sesión:<br><br>"+
              "<b>Usuario: </b>" +
              `${this.extranjero.per_numero_documento}` +
              "<br>" +
              "<b>Contraseña:</b> Nro Documento",
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: "Entendido!",
          });
          router.push({ name: "buscarPersona" });
        }else{
          this.cargando = false;
          this.btnDisabled = false;
          // this.$swal({
          //   title: 'Atención',
          //   html: `<b>${this.extranjero.per_nombres} ${this.extranjero.per_primer_apellido} ${this.extranjero.per_nombres}</b></br> ya fue registrado anteriormente.`,
          //   type: 'warning',
          //   confirmButtonText: 'Aceptar'
          // });
      //     this.$swal({
      //   title: "Atención",
      //   html: `<b>${this.extranjero.per_nombres} ${this.extranjero.per_primer_apellido} ${this.extranjero.per_nombres}</b></br> ya fue registrado anteriormente.`,
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#3085d6",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "desea Declarar",
      // })
          //this.$router.push("historialDeclaracion");
          //this.insertaDomicilioPersona(this.persona);
          this.showModal(this.persona)
        }

      } catch (error) {
        console.log('catch: ', error);
        this.cargando = false;
        this.btnDisabled = false;
        this.$swal({
          title: 'Información',
          text: 'Se ha producido un error, intente nuevamente registrar o vuelva ingresar al sistema.',
          type: 'error',
          confirmButtonText: 'Aceptar'
        });
      }
    },
   async insertaDomicilioPersona(datos_persona){
  let res = await this.axios.post(`/registarDomicilioExtranjero`, datos_persona);
        if(res.data.codigo === 1){
     
          this.cargando = false;
          this.$swal({
            title: "<strong>Declaración Registrada</strong>",
            type: "success",
            html:
              "Declaración Jurada de Domicilio Registrado Exitosamente",
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: "Entendido!",
          });
         this.hideModal();
        }else{
          this.cargando = false;
          this.$swal({
            title: "<strong>Cuenta Empresa</strong>",
            type: "success",
            html:
              "Es una cuenta de empresa no se puede realizar una declaración",
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false,
            confirmButtonAriaLabel: "Entendido!",
          });
          this.hideModal();
        }
    },
    async getTipoDocumento() {
      try {
        await this.axios
          .get(`/getParametros/DOCUMENTO`)
          .then((response) => {
            this.tipoDocumentos = response.data.contenido;
          })
          .catch((error) => {
            console.log('catch: ', error);
          });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getNacionalidades() {
      let config = { headers: { token: this.token } };
      try {
        await this.axios.get(`/parametrosPaises`, config)
        .then((response) => {
          this.nacionalidades = response.data.contenido;
        })
        .catch((error) => {
          console.log('catch: ', error);
        });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    onChangeNaionalidad(event) {
      this.extranjero.nacionalidad = event.target.options[event.target.selectedIndex].text;
    },
    onChangeTipoDomicilio() {
      let opcion = this.domicilio.tipo_domicilio;
      switch (opcion) {
        case "HOS":
          this.disabledHos = 1;
          this.disabledRes = 0;
          this.disabledND = 0;
          break;
        case "RES":
          this.disabledHos = 0;
          this.disabledRes = 1;
          this.disabledND = 0;
          break;
        case "ND":
          this.disabledHos = 0;
          this.disabledRes = 0;
          this.disabledND = 1;
          break;      
      }
      this.domicilio.fecha_inicio = '';
      this.domicilio.fecha_fin = '';
    },
    ofusca: function(cadena) {
      return window.btoa(cadena);
    },
    validaField(){
      if(this.disabledHos==1){
        this.domicilio.nombre_domicilio = "";
        this.domicilio.nro_documento = "";
        if(this.domicilio.id_empresa == undefined || this.domicilio.id_empresa == 0){
          this.valid = false;
        }
      }
      if(this.disabledRes==1){
        this.domicilio.id_empresa = 0;
        if (this.domicilio.nombre_domicilio == undefined || this.domicilio.nombre_domicilio == "") {
          this.valid = false;
        }

        if (this.domicilio.nro_documento == undefined || this.domicilio.nro_documento == "") {
          this.valid = false;
        }
      }
      return this.valid;
    },
    async verificarImpresión() {
      try {
        let resultado = await this.axios.get(`/verificarImpresion`);
        let codigo = resultado.data.contenido[0].orden;
        if(codigo==1){
          this.impresora=true;
        }
      } catch (error) {

        console.log(error);
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
    guardaIdioma (){
      localStorage.setItem("idioma", this.idioma);
    }
  },
  created() {
    this.idioma = Number(localStorage.getItem("idioma"));
    this.getNacionalidades();
    this.getTipoDocumento();
    this.verificarImpresión();
  },
  validations: {
    extranjero: {
      per_nombres: { required, minLength: minLength(2), letras },
      per_primer_apellido: { required, minLength: minLength(2), letras },
      per_segundo_apellido: { minLength: minLength(2), letras },
      per_telefono: { required, minLength: minLength(6), numero},
      par_tipo_documento: { required },
      per_numero_documento: { required, minLength: minLength(5) },
      per_fecha_nacimiento: {  },
      par_genero: {  },
      par_nacionalidad: {required},
      per_email: {email},
      tipo_extranjero: {required},
    },
    domicilio: {
      tipo_domicilio: { required }
    },
  },
};
</script>
